/* =============================================================================
   EOH FRONTEND STYLES — eoh-fdstyle.js
   All visual styles for the ERP Online Hub chat interface live here.
   Edit this file to change colours, sizes, animations, and component looks.
   Load this BEFORE eoh-chat.js in page_erp-chat.liquid:
     <script src="{{ 'eoh-fdstyle.js' | asset_url }}"></script>
     <script src="{{ 'eoh-chat.js' | asset_url }}"></script>
   ============================================================================= */

(function () {
  if (document.getElementById('eoh-fdstyle')) return;

  /* ── Design tokens — change these to restyle everything ─────────────────── */
  var T = {
    /* Brand colours */
    green:        '#0fb574',
    greenDark:    '#0a8a5f',
    greenAlpha15: 'rgba(10,138,95,.15)',
    greenAlpha12: 'rgba(10,138,95,.12)',
    greenAlpha10: 'rgba(10,138,95,.10)',
    greenAlpha06: 'rgba(10,138,95,.06)',

    /* Backgrounds */
    bg:   '#0a1520',
    bg2:  '#0d1828',
    bg3:  '#111827',

    /* Text */
    text:  '#e8edf5',
    muted: '#8fa3bf',
    dim:   '#7d8ba3',

    /* Borders */
    border: 'rgba(255,255,255,.08)',

    /* Danger */
    red:    '#f87171',
    redBg:  'rgba(239,68,68,.1)',
    redBdr: '#f87171',

    /* Stars */
    star:       '#3a4560',
    starActive: '#f59e0b',

    /* Cursor */
    cursorSize:  '18px',
    cursorGlow:  'rgba(10,138,95,.5)',

    /* Typing status text */
    statusSize:  '13px',

    /* Sources accordion */
    sourcesRadius: '10px',
    sourcesBg:     'rgba(13,24,40,.8)',

    /* Image cards */
    imgRadius:   '12px',
    imgMaxH:     '320px',

    /* Vote buttons */
    voteRadius:  '20px',
  };

  /* ── Build style string ──────────────────────────────────────────────────── */
  var css = [

    /* ── Streaming cursor ─────────────────────────────────────────────────── */
    '@keyframes eohPulse{0%,100%{opacity:.6;transform:scale(.9)}50%{opacity:1;transform:scale(1.1)}}',
    '.stream-cursor{display:inline-block;width:' + T.cursorSize + ';height:' + T.cursorSize + ';vertical-align:middle;margin-left:4px}',
    '.stream-cursor img{width:100%;height:100%;object-fit:contain;border-radius:3px;animation:eohPulse 1s ease-in-out infinite;filter:drop-shadow(0 0 4px ' + T.cursorGlow + ')}',

    /* ── Typing status text ───────────────────────────────────────────────── */
    '.eoh-status{display:inline;margin-left:8px;font-size:' + T.statusSize + ';color:' + T.green + ';font-weight:500}',
    '.eoh-pre-dots{display:flex;align-items:center}',
    '#typing .mav{background:transparent!important;box-shadow:none!important}',

    /* ── Sources accordion ────────────────────────────────────────────────── */
    '.eoh-sources{margin-top:14px;border:1px solid ' + T.border + ';border-radius:' + T.sourcesRadius + ';background:' + T.sourcesBg + ';overflow:hidden}',
    '.eoh-sources-hdr{display:flex;align-items:center;justify-content:space-between;padding:10px 14px;cursor:pointer}',
    '.eoh-sources-hdr:hover{background:rgba(255,255,255,.03)}',
    '.eoh-sources-hdr span{font-size:12px;font-weight:600;color:' + T.muted + '}',
    '.eoh-sources-cnt{font-size:10px;background:' + T.greenAlpha15 + ';color:' + T.green + ';padding:2px 8px;border-radius:10px}',
    '.eoh-sources-arr{transition:transform .2s}',
    '.eoh-sources.open .eoh-sources-arr{transform:rotate(180deg)}',
    '.eoh-sources-list{max-height:0;overflow:hidden;transition:max-height .25s}',
    '.eoh-sources.open .eoh-sources-list{max-height:300px}',
    '.eoh-src-item{display:flex;align-items:center;gap:10px;padding:10px 14px;border-top:1px solid rgba(255,255,255,.06)}',
    '.eoh-src-item:hover{background:rgba(255,255,255,.02)}',
    '.eoh-src-n{min-width:18px;height:18px;display:flex;align-items:center;justify-content:center;background:' + T.greenAlpha12 + ';color:' + T.green + ';font-size:9px;font-weight:700;border-radius:50%}',
    '.eoh-src-info{flex:1;overflow:hidden}',
    '.eoh-src-t{font-size:11px;color:' + T.text + ';white-space:nowrap;overflow:hidden;text-overflow:ellipsis}',
    '.eoh-src-u{font-size:10px;color:' + T.dim + '}',
    '.eoh-src-link{padding:4px 8px;background:' + T.greenAlpha15 + ';color:' + T.green + ';text-decoration:none;border-radius:4px;font-size:10px}',
    '.eoh-src-link:hover{background:rgba(10,138,95,.3)}',

    /* ── Image cards ──────────────────────────────────────────────────────── */
    '.eoh-img-card{background:' + T.bg2 + ';border:1px solid ' + T.border + ';border-radius:' + T.imgRadius + ';overflow:hidden;margin:10px 0;transition:border-color .2s}',
    '.eoh-img-card:hover{border-color:rgba(10,138,95,.4)}',
    '.eoh-img-wrap{position:relative;background:' + T.bg3 + ';min-height:160px;cursor:zoom-in;overflow:hidden}',
    '.eoh-img-wrap img{width:100%;min-height:160px;height:auto;display:block;transition:transform .25s;max-height:' + T.imgMaxH + ';object-fit:cover}',
    '.eoh-img-card:hover .eoh-img-wrap img{transform:scale(1.02)}',
    '@keyframes shimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}',
    '.eoh-img-skeleton{position:absolute;inset:0;background:linear-gradient(90deg,' + T.bg3 + ' 25%,' + T.bg2 + ' 50%,' + T.bg3 + ' 75%);background-size:400px 100%;animation:shimmer 1.4s infinite linear}',
    '.eoh-img-wrap img{opacity:0;transition:opacity .3s}',
    '.eoh-img-badges{display:flex;align-items:center;gap:6px;padding:8px 12px 4px}',
    '.eoh-img-tcode{font-size:10px;font-weight:700;background:rgba(10,138,95,.18);color:' + T.green + ';padding:2px 8px;border-radius:10px;letter-spacing:.05em}',
    '.eoh-img-src{font-size:10px;color:' + T.dim + ';background:rgba(255,255,255,.06);padding:2px 8px;border-radius:10px;border:1px solid ' + T.border + '}',
    '.eoh-img-src.library{background:' + T.greenAlpha10 + ';color:' + T.green + ';border-color:rgba(10,138,95,.2)}',
    '.eoh-img-caption{padding:0 12px 6px}',
    '.eoh-img-screen-name{font-size:12px;font-weight:600;color:' + T.text + ';line-height:1.4}',
    '.eoh-img-table{font-size:10px;color:' + T.dim + ';font-family:monospace;margin-top:1px}',
    '.eoh-img-desc{font-size:11px;color:' + T.muted + ';line-height:1.6;margin-top:4px;padding:0 12px 8px}',

    /* ── Rating stars ─────────────────────────────────────────────────────── */
    '.eoh-stars{display:flex;align-items:center;gap:6px;margin-top:6px;padding:4px 0}',
    '.eoh-stars-label{font-size:10px;color:' + T.muted + ';white-space:nowrap}',
    '.eoh-star-row{display:flex;gap:2px}',
    '.eoh-star{font-size:16px;cursor:pointer;color:' + T.star + ';transition:color .1s,transform .1s;user-select:none;line-height:1}',
    '.eoh-star:hover,.eoh-star.hover{color:' + T.starActive + ';transform:scale(1.2)}',
    '.eoh-star.lit{color:' + T.starActive + '}',
    '.eoh-star.rated{cursor:default}',
    '.eoh-stars-thanks{font-size:10px;color:' + T.green + ';margin-left:4px;opacity:0;transition:opacity .3s}',
    '.eoh-stars-thanks.show{opacity:1}',

    /* ── Vote buttons ─────────────────────────────────────────────────────── */
    '.eoh-vote-btn{display:flex;align-items:center;gap:4px;background:none;border:1px solid rgba(255,255,255,.1);cursor:pointer;font-size:12px;padding:4px 10px;border-radius:' + T.voteRadius + ';color:' + T.muted + ';transition:all .15s;font-family:var(--font,inherit)}',
    '.eoh-vote-btn:hover{background:rgba(255,255,255,.08);border-color:rgba(255,255,255,.2)}',
    '.eoh-vote-btn.liked{background:' + T.greenAlpha15 + ';border-color:' + T.green + ';color:' + T.green + ';font-weight:600}',
    '.eoh-vote-btn.disliked{background:' + T.redBg + ';border-color:' + T.redBdr + ';color:' + T.redBdr + '}',
    '.eoh-vote-count{font-size:11px;font-weight:600}',

    /* ── Image grid ───────────────────────────────────────────────────────── */
    '.eoh-img-grid{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin:10px 0}',
    '.eoh-img-grid.single{grid-template-columns:1fr;max-width:520px}',
    '@media(max-width:480px){.eoh-img-grid{grid-template-columns:1fr}}',

  ].join('');

  /* ── Inject into <head> ──────────────────────────────────────────────────── */
  var s = document.createElement('style');
  s.id = 'eoh-fdstyle';
  s.textContent = css;
  document.head.appendChild(s);

  /* ── Expose tokens for runtime access if needed ──────────────────────────── */
  window.EOH_STYLE = T;

})();


/* =============================================================================
   EOH TYPING INDICATOR & STREAM CURSOR — runtime behaviour
   Defines: showTyping, removeTyping, _animateStatus, _stopStatusAnim,
            _getLogoSrc, _buildCursorSrc, toggleSrc
   These globals are called by eoh-chat.js — keep this file loaded first.
   ============================================================================= */

(function () {

  /* ── Status messages — edit these to change what users see while waiting ─── */
  window._statusMsgs = [
    'Analyzing your question',
    'Searching documentation',
    'Finding information',
    'Preparing response'
  ];

  /* ── Sequence-ID animation engine ────────────────────────────────────────── */
  window._animSeq = 0;

  window._animateStatus = function (elId) {
    var mySeq = ++window._animSeq;
    var mi = 0, ci = 0;
    function type() {
      if (window._animSeq !== mySeq) return;
      var el = document.getElementById(elId);
      if (!el) return;
      var msg = window._statusMsgs[mi];
      if (ci <= msg.length) {
        el.textContent = msg.substring(0, ci++);
        setTimeout(type, 50);
      } else {
        setTimeout(function () {
          mi = (mi + 1) % window._statusMsgs.length;
          ci = 0;
          type();
        }, 1500);
      }
    }
    type();
  };

  window._stopStatusAnim = function () { window._animSeq++; };

  /* ── Logo / cursor source — resolved once, cached forever ────────────────── */
  window._eohCursorSrc = '';

  window._getLogoSrc = function () {
    if (window._eohCursorSrc) return window._eohCursorSrc;
    var ml = document.getElementById('main-logo');
    var attr = ml ? (ml.getAttribute('src') || '') : '';
    var src = (attr && attr.length > 4) ? ml.src : (window._chatLogo || '');
    if (src && src.length > 4) window._eohCursorSrc = src;
    return window._eohCursorSrc;
  };

  window._buildCursorSrc = function (callback) {
    if (window._eohCursorSrc) { callback(window._eohCursorSrc); return; }
    var src = window._getLogoSrc();
    if (!src) { callback(''); return; }
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = img.naturalWidth || 32;
        c.height = img.naturalHeight || 32;
        c.getContext('2d').drawImage(img, 0, 0);
        window._eohCursorSrc = c.toDataURL();
      } catch (e) {
        window._eohCursorSrc = src;
      }
      callback(window._eohCursorSrc);
    };
    img.onerror = function () { window._eohCursorSrc = src; callback(src); };
    img.src = src;
  };

  (function _prewarm() {
    function _try() {
      if (window._getLogoSrc()) { window._buildCursorSrc(function () {}); }
      else { setTimeout(_try, 300); }
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { setTimeout(_try, 200); });
    } else {
      setTimeout(_try, 200);
    }
  })();

  /* ── showTyping / removeTyping ───────────────────────────────────────────── */
  window.showTyping = function () {
    var m = document.getElementById('msgs');
    if (!m || document.getElementById('typing')) return;
    var el = document.createElement('div');
    el.className = 'msg assistant';
    el.id = 'typing';

    // Get logo — try all sources
    var logoSrc = window._eohCursorSrc || '';
    if (!logoSrc) {
      var ml = document.getElementById('main-logo');
      if (ml && ml.src && ml.src.length > 10) logoSrc = ml.src;
    }
    if (!logoSrc) logoSrc = window._chatAnalyzingLogo || window._chatLogo || '';

    // Always use transparent background — logo image covers it when loaded
    var mavHtml = '<div class="mav" style="background:transparent!important;box-shadow:none">'
      + (logoSrc ? '<img src="' + logoSrc + '" alt="AI" style="width:100%;height:100%;object-fit:contain;padding:2px">' : '')
      + '</div>';

    el.innerHTML = mavHtml +
      '<div class="mbody">' +
      '<div id="eoh-status-text" style="font-size:12px;color:var(--muted);font-weight:500;margin-bottom:6px;min-height:16px"></div>' +
      '<div class="tdots"><span></span><span></span><span></span></div>' +
      '</div>';

    m.appendChild(el);
    m.scrollTop = m.scrollHeight;
    window._animateStatus('eoh-status-text');

    // Retry logo if not available yet
    if (!logoSrc) {
      setTimeout(function () {
        var mav = el.querySelector('.mav');
        var ml2 = document.getElementById('main-logo');
        var src = window._eohCursorSrc || (ml2 && ml2.src && ml2.src.length > 10 ? ml2.src : '');
        if (mav && src && !mav.querySelector('img')) {
          mav.innerHTML = '<img src="' + src + '" alt="AI" style="width:100%;height:100%;object-fit:contain;padding:2px">';
        }
      }, 500);
    }
  };

  window.removeTyping = function () {
    window._stopStatusAnim();
    var t = document.getElementById('typing');
    if (t) t.remove();
  };

  /* ── Sources accordion toggle ────────────────────────────────────────────── */
  window.toggleSrc = function (id) {
    var e = document.getElementById(id);
    if (e) e.classList.toggle('open');
  };

})();


/* =============================================================================
   EOH TYPEWRITER ENGINE — character-by-character response reveal
   Adjust TW_SPEED to control typing speed (ms per character).
   ============================================================================= */

(function () {

  var TW_SPEED       = 6;    // ms per tick (kept clamp-safe; browsers floor setTimeout at ~4ms)
  var TW_STEP        = 4;    // characters revealed per tick — this is the 4x speed multiplier
  var TW_PAUSE_END   = 20;   // extra pause after sentence-ending punctuation (scaled for 4x)
  var TW_PAUSE_COMMA = 9;    // extra pause after comma / colon / semicolon (scaled for 4x)
  var TW_PAUSE_NL    = 15;   // extra pause after newline (scaled for 4x)
  var TW_SKIP_THRESH = 99999; // effectively disabled — all messages type letter by letter

  var tw = {
    shown:  '',
    queue:  '',
    active: false,
    bubble: null,
    msgs:   null,
    done:   false,
    onDone: null
  };
  window._eohTw = tw;

  function _twCursor() {
    var cs = (window._getLogoSrc ? window._getLogoSrc() : '') || window._eohCursorSrc || '';
    return cs
      ? '<span class="stream-cursor"><img src="' + cs + '"></span>'
      : '<span class="stream-cursor">&#9646;</span>';
  }

  function _twRender(text) {
    var s = text
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
      .replace(/\*([^*]+)\*/g, '<em>$1</em>')
      .replace(/`([^`]+)`/g, '<code>$1</code>');
    s = s.replace(/\n\n/g, '</p><p>').replace(/\n/g, '<br>');
    return '<p>' + s + '</p>';
  }

  function _twRun() {
    if (!tw.queue.length) {
      tw.active = false;
      if (tw.done && tw.onDone) {
        var cb = tw.onDone;
        tw.onDone = null;
        cb();
      }
      return;
    }
    tw.active = true;
    // Reveal a batch of characters per tick — gives a real 4x without hitting the ~4ms timer floor
    var step  = Math.min(TW_STEP, tw.queue.length);
    var batch = tw.queue.slice(0, step);
    tw.queue  = tw.queue.slice(step);
    tw.shown += batch;

    if (tw.bubble) {
      tw.bubble.innerHTML = _twRender(tw.shown) + _twCursor();
      if (tw.msgs) tw.msgs.scrollTop = tw.msgs.scrollHeight;
    }

    var delay = TW_SPEED;
    if (/[.!?]/.test(batch)) delay += TW_PAUSE_END;
    else if (/[,:;]/.test(batch)) delay += TW_PAUSE_COMMA;
    else if (batch.indexOf('\n') >= 0) delay += TW_PAUSE_NL;

    setTimeout(_twRun, delay);
  }

  /* ── Public API ──────────────────────────────────────────────────────────── */

  window._eohTwInit = function (bubbleEl, msgsEl) {
    tw.shown  = '';
    tw.queue  = '';
    tw.active = false;
    tw.done   = false;
    tw.onDone = null;
    tw.bubble = bubbleEl;
    tw.msgs   = msgsEl || document.getElementById('msgs');
  };

  window._eohTwFeed = function (fullAccumulated) {
    var already = tw.shown.length + tw.queue.length;
    var newChars = fullAccumulated.slice(already);
    if (!newChars) return;
    tw.queue += newChars;
    if (!tw.active) _twRun();
  };

  window._eohTwFinish = function (finalText, onDone) {
    tw.done = true;

    function _showFinal() {
      if (!tw.bubble) { if (onDone) onDone(); return; }
      var html = (typeof formatMarkdown === 'function')
        ? formatMarkdown(finalText)
        : _twRender(finalText);
      tw.bubble.innerHTML = html + _twCursor();
      if (tw.msgs) tw.msgs.scrollTop = tw.msgs.scrollHeight;
      var bEl = tw.bubble;
      setTimeout(function () {
        if (bEl) bEl.innerHTML = (typeof formatMarkdown === 'function')
          ? formatMarkdown(finalText)
          : _twRender(finalText);
        if (onDone) onDone();
      }, 700);
    }

    if (!tw.active && !tw.queue.length) {
      _showFinal();
    } else if (tw.queue.length > TW_SKIP_THRESH) {
      tw.queue  = '';
      tw.active = false;
      tw.shown  = finalText;
      _showFinal();
    } else {
      tw.onDone = _showFinal;
    }
  };

})();
